import { foldText } from "./foldText";

export const filterByLabel = <T extends { label: string }>(items: T[], query: string): T[] => {
    const folded = foldText(query);

    return folded === "" ? items : items.filter((item) => foldText(item.label).includes(folded));
};
